// extracted by mini-css-extract-plugin
export default {"title":"Item_title__WqShq","image":"Item_image__LGusi","wrapper":"Item_wrapper__c+DnN"};